import React from "react"
import { Card, CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import { DetailText } from "../../../../../component/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { useTranslation } from "react-i18next"
import { FIELD_OFFICER_ROLE_ENUM } from "../../../../../constants/StringConstant.js"
import { stringFormatting } from "../../../../helpers/TextHelper.js"
import { useFormikContext } from "formik"
import { useSelector } from "react-redux"

export const PreviewFieldOfficer = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext()
  const { FieldOfficer, MasterData } = useSelector((state) => state)
  const roleFO = FieldOfficer?.role?.find((e) => e?.name === values?.roleFO) ?? {}
  return (
    <Card>
      <CardHeader title={t("label_review_data_team_operational")} />
      <CardBody>
        <RowModule>
          <Card>
            <CardHeader title={t("label_profile_picture").toUpperCase()} />
            <CardBody>
              <DetailText type="image" value={values?.avatar} />
            </CardBody>
          </Card>
        </RowModule>
        <RowModule>
          <Card>
            <CardHeader title={t("label_data_operational_team").toUpperCase()} />
            <CardBody>
              <DetailText title={t("label_role")} value={stringFormatting(roleFO.display_name)} />
              {roleFO && (
                <>
                  {(roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD) && (
                      <DetailText
                        title={t("label_regional")}
                        value={stringFormatting(
                          MasterData.listRegionalAll?.find((e) => e?.id === values?.regional)?.name
                        )}
                      />
                    )}
                  {(roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR) && (
                      <DetailText
                        title={t("label_sub_regional")}
                        value={
                          Array.isArray(values.subRegional)
                            ? values.subRegional.length > 0
                              ? MasterData?.detailRegional?.list_sub_regional
                                ?.filter((e) => values.subRegional.includes(e.id))
                                .map((item) => item.name ?? "-")
                                .join(", ")
                              : "-"
                            : "-"
                        }
                      />
                    )}
                  {(
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
                    roleFO?.name === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV
                  ) && (
                      <DetailText title={t("sub_header_base")} value={stringFormatting(
                        MasterData?.listBaseBySubRegional.find((item) => item?.id === values?.base)?.name
                      )} />
                    )}

                </>
              )}
              <DetailText title={t("label_name")} value={stringFormatting(values?.name)} />
              <DetailText title={t("label_phone_number")} value={stringFormatting(values?.phone)} />
              <DetailText title={t("label_email")} value={stringFormatting(values?.email)} />
              <DetailText
                title={t("label_address").toUpperCase()}
                type="address"
                value={
                  values?.foAddress +
                  ", " +
                  values?.foPostalCode +
                  ", " +
                  (MasterData?.subDistrictList || []).find((e) => e?.id === values?.foSubDistrict)
                    ?.name +
                  ", " +
                  (MasterData?.districtList || []).find((e) => e?.id === values?.foDistrict)?.name +
                  ", " +
                  (MasterData?.regencyList || []).find((e) => e?.id === values?.foRegency)?.name +
                  ", " +
                  (MasterData?.provinceList || []).find((e) => e?.id === values?.foProvince)?.name
                }
              />
            </CardBody>
          </Card>
        </RowModule>
      </CardBody>
    </Card>
  )
}